module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/search/searchresultlistitem/searchresultlistitem.component.css
// module id = ./src/app/search/searchresultlistitem/searchresultlistitem.component.css
// module chunks = main